export default (buckets, response, distributionMetric) => (response && distributionMetric) ? buckets.map((bucket) => {
  const row = response.find((engagement) => {
    const dimension = distributionMetric.dimension;
    return engagement[dimension] === bucket;
  });
  if (!row) {
    return null;
  }
  const metric = distributionMetric.metric
  return row[metric];
}) : response;
